// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1GvV9","errorLogs":"styles_errorLogs__3AB2t"};